import { composeConfigs, PreviewWeb, ClientApi } from '@storybook/preview-api';
  import '/virtual:/@storybook/builder-vite/setup-addons.js';
  import { importFn } from '/virtual:/@storybook/builder-vite/storybook-stories.js';
  
    
  const getProjectAnnotations = async () => {
    const configs = await Promise.all([import('@storybook/web-components/preview'),
import('@storybook/addon-essentials/docs/preview'),
import('@storybook/addon-essentials/actions/preview'),
import('@storybook/addon-essentials/backgrounds/preview'),
import('@storybook/addon-essentials/measure/preview'),
import('@storybook/addon-essentials/outline/preview'),
import('@storybook/addon-essentials/highlight/preview'),
import('@storybook/addon-styling/preview'),
import('/.storybook/preview.ts')])
    return composeConfigs(configs);
  }

    window.__STORYBOOK_PREVIEW__ = window.__STORYBOOK_PREVIEW__ || new PreviewWeb();
    
    window.__STORYBOOK_STORY_STORE__ = window.__STORYBOOK_STORY_STORE__ || window.__STORYBOOK_PREVIEW__.storyStore;
    window.__STORYBOOK_CLIENT_API__ = window.__STORYBOOK_CLIENT_API__ || new ClientApi({ storyStore: window.__STORYBOOK_PREVIEW__.storyStore });
    window.__STORYBOOK_PREVIEW__.initialize({ importFn, getProjectAnnotations });
    
    if (import.meta.hot) {
        import.meta.hot.decline();
      };